import { FASTAG_LOWEST_SUFFICIENT_BALANCE } from '@components/MainWidget/FastagWidget/constants'

export const fastagBalanceContainerData = fastagUserData => {
  const hasBalanceContainer = !!fastagUserData?.fastagData
  const balanceValue = Number(fastagUserData?.fastagData?.balance || 0)
  const isBalanceLow = balanceValue < FASTAG_LOWEST_SUFFICIENT_BALANCE

  return { hasBalanceContainer, balanceValue, isBalanceLow }
}
